export const WORKFLOW_BUCKETS = Object.freeze({
  PENDING_TRANSFERS: "PENDING_TRANSFERS",
  RECEIVE_RETURNS: "RECEIVE_RETURNS",
});